import { Box, Checkbox, Typography, useTheme } from "@mui/material";
import { useCallback, useState } from "react";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { MdOutlineRadioButtonUnchecked } from "react-icons/md";

export function ToggleAll(props) {
  const { toggle } = props || {};
  const [checked, setChecked] = useState(false);
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const onToggleAll = useCallback(
    (e) => {
      const next = e.target.checked;
      toggle(next);
      setChecked(next);
    },
    [toggle]
  );

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "center" }}>
      <Checkbox
        size="small"
        disableRipple
        checked={checked}
        onChange={onToggleAll}
        icon={<MdOutlineRadioButtonUnchecked size={20} />}
        checkedIcon={<IoMdCheckmarkCircleOutline size={20} />}
        sx={{ p: 0, color: isDark ? "#4ade80" : "#334155", "&.Mui-checked": { color: "#659d33" } }}
      />
      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: 600,
          fontFamily: "'Poppins', sans-serif",
          textTransform: "none",
          color: isDark ? "#4ade80" : "#334155",
          display: "inline-block",
          ml: 1
        }}
      >
        {props.displayName}
      </Typography>
    </Box>
  );
}
